import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-clicks",
  templateUrl: "./clicks.component.html",
  styleUrls: ["./clicks.component.scss"]
})
export class ClicksComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
